<template>
  <vs-row vs-w="12">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="self-start">
      <vx-card title="Últimas avaliações">
        <vs-list>
          <vs-list-item
            icon-pack="feather"
            icon="icon-check"
            :key="indextr"
            v-for="(evaluation, indextr) in classEvaluations"
            :title="evaluation.created_at"
          >
            <vs-chip color="success">Aula avaliada!</vs-chip>
          </vs-list-item>
        </vs-list>
      </vx-card>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8" class="self-start">
      <div v-if="!this.canEvaluate">
          
        <p>Avaliação de aula não disponível. Talvez não seja seu dia de aula ou você já tenha avaliado hoje.</p>
      </div>
      <vx-card v-if="this.canEvaluate" class="flex justify-center py-10 items-center">
        <h2 class="text-center mb-5">
          Avalie sua aula de hoje com o professor
          <div>
            <strong>{{ account.user.student.class.teacher.nome }}</strong>!
          </div>
        </h2>
        <vs-chip v-if="ratingText" color="primary" class="float-none my-10 self-center">{{ ratingText }}</vs-chip>
        <star-rating
          class="flex justify-center my-10"
          :show-rating="false"
          @rating-selected="setRating"
          :border-width="4"
          border-color="#d8d8d8"
          :rounded-corners="true"
          :glow="10"
          :star-size="80"
          active-color="#EA5455"
          :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
        ></star-rating>
        <vs-textarea
          label="Deseja fazer alguma observação sobre a sua avaliação? É opcional!"
          v-model="notes"
        />
        <template slot="footer">
          <div class="flex justify-center">
            <vs-button
              icon="check"
              v-if="rating"
              color="primary"
              class="mt-10 flex-grow-0"
              type="gradient"
              @click="submitClassEvaluation()"
            >Avaliar</vs-button>
          </div>
        </template>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapState } from "vuex";
import StarRating from "vue-star-rating";
import {
  canEvaluate,
  createClassEvaluation,
  getClassEvaluations
} from "../../_services/classEvaluation.service.js";

export default {
  data() {
    return {
      canEvaluate: false,
      classEvaluations: [],
      rating: null,
      ratingText: "",
      notes: ""
    };
  },
  components: {
    StarRating
  },
  methods: {
    setRating: function(rating) {
      this.rating = rating;
      this.ratingText =
        rating == 1
          ? "Muito ruim"
          : rating < 3
          ? "Ruim"
          : rating < 4
          ? "Boa"
          : rating == 4
          ? "Muito boa"
          : "Excelente";
    },
    async submitClassEvaluation() {
      this.$vs.loading();
      await createClassEvaluation({ rating: this.rating, notes: this.notes });
      this.$vs.loading.close();
      location.reload();
    }
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  async created() {
    this.$vs.loading();
    this.canEvaluate = await canEvaluate();
    this.classEvaluations = await getClassEvaluations({
      student_id: this.account.user.student.id
    });
    this.$vs.loading.close();
  },
  async mounted() {}
};
</script>